type AddressMetadata = {
  address?: string | null
  address2?: string | null
  city?: string | null
  country?: string | null
  state?: string | null
  zip?: string | null
}

export function formatAddress({
  address,
  address2,
  city,
  country,
  state,
  zip,
}: AddressMetadata): string {
  return [address, address2, city, state, zip, country]
    .filter(Boolean)
    .join(', ')
}
